import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";

export const fetchRawDetails = (rawId) =>
  new Promise((resolve, reject) => {
    sendAuthenticatedAsyncRequest(
      `/raw/${rawId}`,
      "GET",
      null,
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });

export const submitDisposition = (rawId, dispositionPayload, faxProgram = "STD") =>
  new Promise((resolve, reject) => {
    const body = { faxProgram, ...dispositionPayload };

    sendAuthenticatedAsyncRequest(
      `/raw/${rawId}/confirm-disposition`,
      "POST",
      body,
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });

export const SUBMIT_TO_PAW_REVIEWER_VALUE = "PAW";

export const buildSubmitForReviewRequestBody = ({
  reviewerId,
  note,
}) => {
  const submitToPaw = reviewerId === SUBMIT_TO_PAW_REVIEWER_VALUE;

  return {
    reviewerId: submitToPaw ? null : reviewerId,
    submitToPaw,
    notesForReviewer: { note: String(note || "").trim() },
  };
};

export const submitRawForReview = (rawId, submitForReviewPayload) =>
  new Promise((resolve, reject) => {
    sendAuthenticatedAsyncRequest(
      `/raw/${rawId}/submit-for-review`,
      "POST",
      submitForReviewPayload,
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });

export const unclaimRaw = (rawId) =>
  new Promise((resolve, reject) => {
    sendAuthenticatedAsyncRequest(
      `/raw/${rawId}/unclaim`,
      "POST",
      null,
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });

export const discardRaw = (rawId) =>
  new Promise((resolve, reject) => {
    sendAuthenticatedAsyncRequest(
      `/raw/${rawId}/discard`,
      "POST",
      null,
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });

export const unlinkDeclinedFax = (rawId, note) =>
  new Promise((resolve, reject) => {
    sendAuthenticatedAsyncRequest(
      `/raw/${rawId}/unlink-fax`,
      "PUT",
      { note },
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
